export const countryCoordinates = {
  AE: {
    loc: [54.3773, 24.2992],
    name: "United Arab Emirates",
  },
  AF: {
    loc: [67.709, 33.9391],
    name: "Afghanistan",
  },
  AG: {
    loc: [-61.7969, 17.0608],
    name: "Antigua and Barbuda",
  },
  AI: {
    loc: [-63.0686, 18.2206],
    name: "Anguilla",
  },
  AL: {
    loc: [20.1683, 41.1533],
    name: "Albania",
  },
  AM: {
    loc: [45.0382, 40.0691],
    name: "Armenia",
  },
  AO: {
    loc: [17.8739, -11.2027],
    name: "Angola",
  },
  AR: {
    loc: [-63.6167, -38.4161],
    name: "Argentina",
  },
  AS: {
    loc: [-170.13, -14.271],
    name: "American Samoa",
  },
  AT: {
    loc: [14.5501, 47.5162],
    name: "Austria",
  },
  AU: {
    loc: [133.7751, -25.2744],
    name: "Australia",
  },
  AW: {
    loc: [-69.9683, 12.5211],
    name: "Aruba",
  },
  AZ: {
    loc: [47.5769, 40.1431],
    name: "Azerbaijan",
  },
  BA: {
    loc: [17.6791, 43.9159],
    name: "Bosnia and Herzegovina",
  },
  BB: {
    loc: [-59.5432, 13.1939],
    name: "Barbados",
  },
  BD: {
    loc: [90.3563, 23.685],
    name: "Bangladesh",
  },
  BE: {
    loc: [4.4699, 50.5039],
    name: "Belgium",
  },
  BF: {
    loc: [-2.157, 12.2383],
    name: "Burkina Faso",
  },
  BG: {
    loc: [25.4858, 42.7339],
    name: "Bulgaria",
  },
  BH: {
    loc: [50.6375, 26.0667],
    name: "Bahrain",
  },
  BI: {
    loc: [29.9189, -3.3731],
    name: "Burundi",
  },
  BJ: {
    loc: [2.3158, 9.3077],
    name: "Benin",
  },
  BM: {
    loc: [-64.7505, 32.3078],
    name: "Bermuda",
  },
  BN: {
    loc: [114.7277, 4.5353],
    name: "Brunei",
  },
  BO: {
    loc: [-63.5887, -16.2902],
    name: "Bolivia",
  },
  BR: {
    loc: [-51.9253, -14.2351],
    name: "Brazil",
  },
  BS: {
    loc: [-77.3963, 25.0343],
    name: "Bahamas",
  },
  BT: {
    loc: [90.4336, 27.5142],
    name: "Bhutan",
  },
  BW: {
    loc: [24.6849, -22.3285],
    name: "Botswana",
  },
  BY: {
    loc: [27.9534, 53.7098],
    name: "Belarus",
  },
  BZ: {
    loc: [-88.4976, 17.1899],
    name: "Belize",
  },
  CA: {
    loc: [-106.3468, 56.1304],
    name: "Canada",
  },
  CC: {
    loc: [96.871, -12.1642],
    name: "Cocos Islands",
  },
  CD: {
    loc: [21.7587, -4.0383],
    name: "Democratic Republic of Congo",
  },
  CF: {
    loc: [20.9394, 6.6111],
    name: "Central African Republic",
  },
  CG: {
    loc: [15.8277, -0.228],
    name: "Republic of Congo",
  },
  CH: {
    loc: [8.2275, 46.8182],
    name: "Switzerland",
  },
  CI: {
    loc: [-5.5471, 7.54],
    name: "Côte d'Ivoire",
  },
  CK: {
    loc: [-159.7777, -21.2367],
    name: "Cook Islands",
  },
  CL: {
    loc: [-71.543, -35.6751],
    name: "Chile",
  },
  CM: {
    loc: [12.3547, 7.3697],
    name: "Cameroon",
  },
  CN: {
    loc: [104.1954, 35.8617],
    name: "China",
  },
  CO: {
    loc: [-74.2973, 4.5709],
    name: "Colombia",
  },
  CR: {
    loc: [-83.7534, 9.7489],
    name: "Costa Rica",
  },
  CU: {
    loc: [-77.7812, 21.5218],
    name: "Cuba",
  },
  CV: {
    loc: [-24.0132, 16.5388],
    name: "Cape Verde",
  },
  CW: {
    loc: [-68.99, 12.1696],
    name: "Curaçao",
  },
  CX: {
    loc: [105.6904, -10.4475],
    name: "Christmas Island",
  },
  CY: {
    loc: [33.4299, 35.1264],
    name: "Cyprus",
  },
  CZ: {
    loc: [15.473, 49.8175],
    name: "Czech Republic",
  },
  DE: {
    loc: [10.4515, 51.1657],
    name: "Germany",
  },
  DJ: {
    loc: [42.5903, 11.8251],
    name: "Djibouti",
  },
  DK: {
    loc: [9.5018, 55.6761],
    name: "Denmark",
  },
  DM: {
    loc: [-61.3707, 15.415],
    name: "Dominica",
  },
  DO: {
    loc: [-70.1627, 18.7357],
    name: "Dominican Republic",
  },
  DZ: {
    loc: [1.6596, 28.0339],
    name: "Algeria",
  },
  EC: {
    loc: [-78.1834, -1.8312],
    name: "Ecuador",
  },
  EE: {
    loc: [25.0136, 58.5953],
    name: "Estonia",
  },
  EG: {
    loc: [30.8025, 26.8206],
    name: "Egypt",
  },
  EH: {
    loc: [-12.8859, 24.2155],
    name: "Western Sahara",
  },
  ER: {
    loc: [39.7823, 15.1794],
    name: "Eritrea",
  },
  ES: {
    loc: [-3.7492, 40.4637],
    name: "Spain",
  },
  ET: {
    loc: [40.4897, 9.145],
    name: "Ethiopia",
  },
  FI: {
    loc: [25.7482, 61.9241],
    name: "Finland",
  },
  FJ: {
    loc: [179.4144, -16.578],
    name: "Fiji",
  },
  FK: {
    loc: [-59.5236, -51.7963],
    name: "Falkland Islands",
  },
  FM: {
    loc: [150.5508, 7.4256],
    name: "Micronesia",
  },
  FO: {
    loc: [-6.9118, 61.8926],
    name: "Faroe Islands",
  },
  FR: {
    loc: [2.2137, 46.2276],
    name: "France",
  },
  GA: {
    loc: [11.6094, -0.8037],
    name: "Gabon",
  },
  GB: {
    loc: [-0.6844, 52.0396],
    name: "United Kingdom",
  },
  GD: {
    loc: [-61.679, 12.2628],
    name: "Grenada",
  },
  GE: {
    loc: [43.3569, 42.3154],
    name: "Georgia",
  },
  GF: {
    loc: [-53.1258, 3.9339],
    name: "French Guiana",
  },
  GG: {
    loc: [-2.5358, 49.4484],
    name: "Guernsey",
  },
  GH: {
    loc: [-1.0232, 7.9465],
    name: "Ghana",
  },
  GI: {
    loc: [-5.3536, 36.1408],
    name: "Gibraltar",
  },
  GL: {
    loc: [-42.6043, 71.7069],
    name: "Greenland",
  },
  GM: {
    loc: [-15.3101, 13.4432],
    name: "Gambia",
  },
  GN: {
    loc: [-9.6966, 9.9456],
    name: "Guinea",
  },
  GP: {
    loc: [-61.551, 16.995],
    name: "Guadeloupe",
  },
  GQ: {
    loc: [10.2679, 1.6508],
    name: "Equatorial Guinea",
  },
  GR: {
    loc: [21.8243, 39.0742],
    name: "Greece",
  },
  GS: {
    loc: [-36.5, -54.5],
    name: "South Georgia and South Sandwich Islands",
  },
  GT: {
    loc: [-90.2308, 15.7835],
    name: "Guatemala",
  },
  GU: {
    loc: [144.7937, 13.4443],
    name: "Guam",
  },
  GW: {
    loc: [-15.1804, 11.8037],
    name: "Guinea-Bissau",
  },
  GY: {
    loc: [-58.9302, 4.8604],
    name: "Guyana",
  },
  HK: {
    loc: [114.1694, 22.3193],
    name: "Hong Kong",
  },
  HM: {
    loc: [73.5044, -53.1],
    name: "Heard Island and McDonald Islands",
  },
  HN: {
    loc: [-87.275, 15.2],
    name: "Honduras",
  },
  HR: {
    loc: [15.2, 45.1],
    name: "Croatia",
  },
  HT: {
    loc: [-72.2852, 18.9712],
    name: "Haiti",
  },
  HU: {
    loc: [19.5033, 47.1625],
    name: "Hungary",
  },
  ID: {
    loc: [113.9213, -0.7893],
    name: "Indonesia",
  },
  IE: {
    loc: [-8.2439, 53.4129],
    name: "Ireland",
  },
  IL: {
    loc: [34.8516, 32.1794],
    name: "Israel",
  },
  IM: {
    loc: [-4.5481, 54.2361],
    name: "Isle of Man",
  },
  IN: {
    loc: [78.4772, 17.4065],
    name: "India",
  },
  IO: {
    loc: [71.8765, -6.3432],
    name: "British Indian Ocean Territory",
  },
  IQ: {
    loc: [43.6793, 33.2232],
    name: "Iraq",
  },
  IR: {
    loc: [53.688, 32.4279],
    name: "Iran",
  },
  IS: {
    loc: [-19.0208, 64.9631],
    name: "Iceland",
  },
  IT: {
    loc: [12.5674, 41.8719],
    name: "Italy",
  },
  JE: {
    loc: [-2.1358, 49.2144],
    name: "Jersey",
  },
  JM: {
    loc: [-77.2975, 18.1096],
    name: "Jamaica",
  },
  JO: {
    loc: [36.2384, 30.5852],
    name: "Jordan",
  },
  JP: {
    loc: [138.2529, 36.2048],
    name: "Japan",
  },
  KE: {
    loc: [37.9062, -0.0236],
    name: "Kenya",
  },
  KG: {
    loc: [74.7661, 41.2044],
    name: "Kyrgyzstan",
  },
  KH: {
    loc: [104.991, 12.5657],
    name: "Cambodia",
  },
  KI: {
    loc: [-157.363, -3.3704],
    name: "Kiribati",
  },
  KM: {
    loc: [43.8721, -11.6455],
    name: "Comoros",
  },
  KN: {
    loc: [-62.783, 17.3578],
    name: "Saint Kitts and Nevis",
  },
  KP: {
    loc: [127.5101, 40.3399],
    name: "North Korea",
  },
  KR: {
    loc: [127.7669, 35.9078],
    name: "South Korea",
  },
  KW: {
    loc: [47.4818, 29.3117],
    name: "Kuwait",
  },
  KY: {
    loc: [-80.5665, 19.5138],
    name: "Cayman Islands",
  },
  KZ: {
    loc: [66.9237, 48.0196],
    name: "Kazakhstan",
  },
  LA: {
    loc: [102.4955, 19.8563],
    name: "Laos",
  },
  LB: {
    loc: [35.8623, 33.8547],
    name: "Lebanon",
  },
  LC: {
    loc: [-60.9789, 13.9094],
    name: "Saint Lucia",
  },
  LI: {
    loc: [9.5215, 47.166],
    name: "Liechtenstein",
  },
  LK: {
    loc: [80.7718, 7.8731],
    name: "Sri Lanka",
  },
  LR: {
    loc: [-9.4295, 6.4281],
    name: "Liberia",
  },
  LS: {
    loc: [28.2336, -29.6097],
    name: "Lesotho",
  },
  LT: {
    loc: [23.8813, 55.1694],
    name: "Lithuania",
  },
  LU: {
    loc: [6.1296, 49.8153],
    name: "Luxembourg",
  },
  LV: {
    loc: [24.6032, 56.8796],
    name: "Latvia",
  },
  LY: {
    loc: [17.2283, 26.3351],
    name: "Libya",
  },
  MA: {
    loc: [-7.0926, 31.7917],
    name: "Morocco",
  },
  MC: {
    loc: [7.4167, 43.7333],
    name: "Monaco",
  },
  MD: {
    loc: [28.3699, 47.4116],
    name: "Moldova",
  },
  ME: {
    loc: [19.3744, 42.7087],
    name: "Montenegro",
  },
  MF: {
    loc: [-63.0501, 18.0708],
    name: "Saint Martin",
  },
  MG: {
    loc: [46.8691, -18.7669],
    name: "Madagascar",
  },
  MH: {
    loc: [171.1845, 7.1315],
    name: "Marshall Islands",
  },
  MK: {
    loc: [21.7453, 41.6086],
    name: "North Macedonia",
  },
  ML: {
    loc: [-3.9962, 17.5707],
    name: "Mali",
  },
  MM: {
    loc: [95.956, 21.9162],
    name: "Myanmar",
  },
  MN: {
    loc: [103.8467, 46.8625],
    name: "Mongolia",
  },
  MO: {
    loc: [113.5439, 22.1987],
    name: "Macao",
  },
  MP: {
    loc: [145.3887, 17.3308],
    name: "Northern Mariana Islands",
  },
  MQ: {
    loc: [-61.0242, 14.6415],
    name: "Martinique",
  },
  MR: {
    loc: [-10.9408, 21.0079],
    name: "Mauritania",
  },
  MS: {
    loc: [-62.1874, 16.7425],
    name: "Montserrat",
  },
  MT: {
    loc: [14.3754, 35.9375],
    name: "Malta",
  },
  MU: {
    loc: [57.5522, -20.3484],
    name: "Mauritius",
  },
  MV: {
    loc: [73.2207, 3.2028],
    name: "Maldives",
  },
  MW: {
    loc: [34.3015, -13.2543],
    name: "Malawi",
  },
  MX: {
    loc: [-102.5528, 23.6345],
    name: "Mexico",
  },
  MY: {
    loc: [101.9758, 4.2105],
    name: "Malaysia",
  },
  MZ: {
    loc: [35.5296, -18.6657],
    name: "Mozambique",
  },
  NA: {
    loc: [18.4241, -22.9576],
    name: "Namibia",
  },
  NC: {
    loc: [165.6189, -20.9043],
    name: "New Caledonia",
  },
  NE: {
    loc: [8.0817, 17.6078],
    name: "Niger",
  },
  NF: {
    loc: [167.9537, -29.0408],
    name: "Norfolk Island",
  },
  NG: {
    loc: [8.6753, 9.082],
    name: "Nigeria",
  },
  NI: {
    loc: [-85.2072, 12.8654],
    name: "Nicaragua",
  },
  NL: {
    loc: [5.2913, 52.1326],
    name: "Netherlands",
  },
  NO: {
    loc: [8.4689, 60.472],
    name: "Norway",
  },
  NP: {
    loc: [84.124, 28.3949],
    name: "Nepal",
  },
  NR: {
    loc: [166.9315, -0.5228],
    name: "Nauru",
  },
  NU: {
    loc: [-169.8672, -19.0544],
    name: "Niue",
  },
  NZ: {
    loc: [174.886, -40.9006],
    name: "New Zealand",
  },
  OM: {
    loc: [55.9754, 21.4735],
    name: "Oman",
  },
  PA: {
    loc: [-80.7821, 8.538],
    name: "Panama",
  },
  PE: {
    loc: [-75.0152, -9.19],
    name: "Peru",
  },
  PF: {
    loc: [-149.4068, -17.6797],
    name: "French Polynesia",
  },
  PG: {
    loc: [143.9555, -6.3149],
    name: "Papua New Guinea",
  },
  PH: {
    loc: [121.774, 12.8797],
    name: "Philippines",
  },
  PK: {
    loc: [69.3451, 30.3753],
    name: "Pakistan",
  },
  PL: {
    loc: [19.1343, 51.9194],
    name: "Poland",
  },
  PM: {
    loc: [-56.3159, 46.9419],
    name: "Saint Pierre and Miquelon",
  },
  PN: {
    loc: [-127.9216, -24.3768],
    name: "Pitcairn",
  },
  PR: {
    loc: [-66.5901, 18.2208],
    name: "Puerto Rico",
  },
  PS: {
    loc: [35.2332, 31.9522],
    name: "Palestine",
  },
  PT: {
    loc: [-8.2245, 39.3999],
    name: "Portugal",
  },
  PW: {
    loc: [134.5825, 7.515],
    name: "Palau",
  },
  PY: {
    loc: [-58.4438, -23.4425],
    name: "Paraguay",
  },
  QA: {
    loc: [51.1839, 25.3548],
    name: "Qatar",
  },
  RE: {
    loc: [55.5364, -21.1151],
    name: "Réunion",
  },
  RO: {
    loc: [24.9668, 45.9432],
    name: "Romania",
  },
  RS: {
    loc: [21.0059, 44.0165],
    name: "Serbia",
  },
  RU: {
    loc: [105.3188, 61.524],
    name: "Russia",
  },
  RW: {
    loc: [29.8739, -1.9403],
    name: "Rwanda",
  },
  SA: {
    loc: [45.0792, 23.8859],
    name: "Saudi Arabia",
  },
  SB: {
    loc: [160.1562, -9.6457],
    name: "Solomon Islands",
  },
  SC: {
    loc: [55.4917, -4.6796],
    name: "Seychelles",
  },
  SD: {
    loc: [30.2176, 12.8628],
    name: "Sudan",
  },
  SE: {
    loc: [18.6435, 60.1282],
    name: "Sweden",
  },
  SG: {
    loc: [103.8198, 1.3521],
    name: "Singapore",
  },
  SH: {
    loc: [-12.2776, -24.1434],
    name: "Saint Helena",
  },
  SI: {
    loc: [14.9955, 46.1512],
    name: "Slovenia",
  },
  SJ: {
    loc: [23.6702, 77.553],
    name: "Svalbard and Jan Mayen",
  },
  SK: {
    loc: [19.699, 48.669],
    name: "Slovakia",
  },
  SL: {
    loc: [-11.7799, 8.4606],
    name: "Sierra Leone",
  },
  SM: {
    loc: [12.4578, 43.9424],
    name: "San Marino",
  },
  SN: {
    loc: [-14.4524, 14.4974],
    name: "Senegal",
  },
  SO: {
    loc: [46.1996, 5.1521],
    name: "Somalia",
  },
  SR: {
    loc: [-56.0278, 3.9193],
    name: "Suriname",
  },
  SS: {
    loc: [31.3069, 6.877],
    name: "South Sudan",
  },
  ST: {
    loc: [6.6131, 0.1864],
    name: "São Tomé and Príncipe",
  },
  SV: {
    loc: [-88.8965, 13.7942],
    name: "El Salvador",
  },
  SX: {
    loc: [-63.2424, 18.0256],
    name: "Sint Maarten",
  },
  SY: {
    loc: [38.9968, 34.8021],
    name: "Syria",
  },
  SZ: {
    loc: [31.4659, -26.5225],
    name: "Eswatini",
  },
  TC: {
    loc: [-71.7979, 21.694],
    name: "Turks and Caicos Islands",
  },
  TD: {
    loc: [18.7322, 15.4542],
    name: "Chad",
  },
  TF: {
    loc: [69.1673, -49.2804],
    name: "French Southern Territories",
  },
  TG: {
    loc: [0.8248, 8.6195],
    name: "Togo",
  },
  TH: {
    loc: [100.9925, 15.87],
    name: "Thailand",
  },
  TJ: {
    loc: [71.2761, 38.861],
    name: "Tajikistan",
  },
  TK: {
    loc: [-172.1015, -8.9675],
    name: "Tokelau",
  },
  TL: {
    loc: [125.7275, -8.8742],
    name: "Timor-Leste",
  },
  TM: {
    loc: [59.5563, 38.9697],
    name: "Turkmenistan",
  },
  TN: {
    loc: [9.5375, 33.8869],
    name: "Tunisia",
  },
  TO: {
    loc: [-175.1982, -21.1789],
    name: "Tonga",
  },
  TR: {
    loc: [35.2433, 38.9637],
    name: "Türkiye",
  },
  TT: {
    loc: [-61.2225, 10.6918],
    name: "Trinidad and Tobago",
  },
  TV: {
    loc: [177.6493, -7.1095],
    name: "Tuvalu",
  },
  TW: {
    loc: [120.9605, 23.6978],
    name: "Taiwan",
  },
  TZ: {
    loc: [34.8888, -6.369],
    name: "Tanzania",
  },
  UA: {
    loc: [31.1656, 48.3794],
    name: "Ukraine",
  },
  UG: {
    loc: [32.2903, 1.3733],
    name: "Uganda",
  },
  UM: {
    loc: [-160.0, 0.0],
    name: "United States Minor Outlying Islands",
  },
  US: {
    loc: [-95.7129, 37.0902],
    name: "United States",
  },
  UY: {
    loc: [-55.7658, -32.5228],
    name: "Uruguay",
  },
  UZ: {
    loc: [64.5853, 41.3775],
    name: "Uzbekistan",
  },
  VA: {
    loc: [12.4534, 41.9029],
    name: "Vatican City",
  },
  VC: {
    loc: [-61.2872, 12.9843],
    name: "Saint Vincent and the Grenadines",
  },
  VE: {
    loc: [-66.5897, 6.4238],
    name: "Venezuela",
  },
  VG: {
    loc: [-64.6963, 18.4207],
    name: "British Virgin Islands",
  },
  VI: {
    loc: [-64.8963, 18.3358],
    name: "U.S. Virgin Islands",
  },
  VN: {
    loc: [108.2772, 14.0583],
    name: "Vietnam",
  },
  VU: {
    loc: [166.9592, -15.3767],
    name: "Vanuatu",
  },
  WF: {
    loc: [-177.156, -13.7687],
    name: "Wallis and Futuna",
  },
  WS: {
    loc: [-172.1046, -13.759],
    name: "Samoa",
  },
  XK: {
    loc: [20.9021, 42.6026],
    name: "Kosovo",
  },
  YE: {
    loc: [48.5164, 15.5527],
    name: "Yemen",
  },
  YT: {
    loc: [45.1662, -12.8275],
    name: "Mayotte",
  },
  ZA: {
    loc: [22.9375, -30.5595],
    name: "South Africa",
  },
  ZM: {
    loc: [27.8546, -13.1339],
    name: "Zambia",
  },
  ZW: {
    loc: [29.1549, -19.0154],
    name: "Zimbabwe",
  },
};
